import gql from 'graphql-tag';

export const getVisitorPassDetailsById = gql`
  query getVisitorPassDetailsById($id: UUID!, $channelId: UUID!) {
    visitorPass(id: $id, channelId: $channelId) {
      id
      visitor {
        firstName
        lastName
        company
        email
        phone
      }
      hostName
      host {
        name
        profile {
          email
          phone
          image
        }
      }
      tenantName
      tenant {
        name
        address {
          name
          street1
          street2
          street3
          city
          state
          country
        }
        profile {
          logo
        }
      }
      accessGrantBuildingId
      floor
      companyName
      status
      visitorNote
      staffNote
      startDatetime
      endDatetime
      submittedBy
      updatedBy
      eventName
      inviteName
      createdAtDatetime
      updatedAtDatetime
      sourceId
      submissionId
      submissionVisitorId
      validStateTransitions
      recurrenceId
      additionalRecipients
      visitorWatchlistMatchInfo {
        watchlistSeverityLevel
        watchlistId
        isApprovalRequired
        isWatchlistDisplayed
        displayText
      }
      watchlistDetails {
        matches {
          visitorWatchlistId
          severityLevel
          displayLevelText
          matchedFields
          notes
          visitorWatchlist {
            id
            organizationId
            visitorMatchingInfo {
              firstName {
                primaryValue
                alternateValues
                matchType
              }
              lastName {
                primaryValue
                alternateValues
                matchType
              }
              email {
                primaryValue
                alternateValues
                matchType
              }
              phone {
                primaryValue
                alternateValues
                matchType
              }
            }
            severityLevel
            notes
            attachmentIds
            reportedBy
            createdBy
            createdByName
            updatedBy
            updatedByName
            createdAt
            updatedAt
          }
        }
        pendingSubmissionVisitors {
          id
          status
          startDatetime
          endDatetime
        }
      }
    }
  }
`;
